import { Stack, Text, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

import { TextWithSubtextSkeleton } from '../../../../../AssetsLoading';
import { FixedIncomeSharedInfoTypes, FixedIncomeSharedInfoTypesLoading } from '../types';

export const NetValueInfo: React.FC<FixedIncomeSharedInfoTypes> = ({
  estimatedNetValueCalculated,
  w,
}) => {
  return (
    <Stack w={w}>
      <VStack space="stack.quarck" justifyContent="space-between">
        <Text variant="semibold">Líquido estimado</Text>
        <Text>{Utils.Mask.Money(estimatedNetValueCalculated)}</Text>
        <Text color="neutral.dark" fontSize="xs">
          No vencimento
        </Text>
      </VStack>
    </Stack>
  );
};

export const NetValueInfoLoading: React.FC<FixedIncomeSharedInfoTypesLoading> = ({ w }) => {
  return (
    <Stack w={w}>
      <VStack space="stack.quarck" justifyContent="space-between">
        <Text variant="semibold">Líquido estimado</Text>
        <TextWithSubtextSkeleton />
      </VStack>
    </Stack>
  );
};
